@if (showLoading) {
    <p-skeleton></p-skeleton>
} @else if (_task) {
    @if (_task.task_type === ECpmCTaskTypeApiEnum.GROUP) {
        <div class="hcol-flex gap-half align-center">
            <div class="hcol-100">
                <p-metergroup [value]="_groupDetail" [pTooltip]="_groupTooltip">
                    <ng-template #label></ng-template>
                </p-metergroup>
            </div>
            <div style="font-weight: normal; width: 4rem; text-align: right">{{ _groupCompletionPct }}%</div>
        </div>
    } @else {
        <div class="hcol-flex gap-half align-center">
            @let tag = _isWaitingForInput ? TaskUtils.waitingForInputTag : TaskUtils.statusTagsByStatus[_task.status];
            <p-tag
                [pTooltip]="tag.tooltip"
                [value]="tag.label"
                [rounded]="false"
                [style]="tag.style!"
                [styleClass]="tag.styleClass"
            >
                <i [class]="tag.icon" [ngStyle]="tag.iconStyle"></i>
            </p-tag>

            @if (_isOutdatedFailed) {
                <p-tag
                    [pTooltip]="TaskUtils.outdatedFailedTag.tooltip"
                    [value]="TaskUtils.outdatedFailedTag.label"
                    [rounded]="false"
                    [style]="TaskUtils.outdatedFailedTag.style!"
                    [styleClass]="TaskUtils.outdatedFailedTag.styleClass"
                >
                    <i [class]="TaskUtils.outdatedFailedTag.icon" [ngStyle]="TaskUtils.outdatedFailedTag.iconStyle"></i>
                </p-tag>
            } @else if (_isOutdated) {
                <p-tag
                    [pTooltip]="TaskUtils.outdatedTag.tooltip"
                    [value]="TaskUtils.outdatedTag.label"
                    [rounded]="false"
                    [style]="TaskUtils.outdatedTag.style!"
                    [styleClass]="TaskUtils.outdatedTag.styleClass"
                >
                    <i [class]="TaskUtils.outdatedTag.icon" [ngStyle]="TaskUtils.outdatedTag.iconStyle"></i>
                </p-tag>
            }
        </div>
    }
}
